import React from 'react'
import styled from 'styled-components'

export const BasePanel = styled.div`
  visibility: hidden;
  opacity: 0;

  transition-property: opacity;
  transition-duration: 150ms;
  transition-delay: 0;

  ${({ open }) =>
    open &&
    `
    visibility: visible;
    opacity: 1;
  `}
`

export default class Panel extends React.Component {
  componentDidMount() {
    document.addEventListener('click', this.onClickOutsidePanel, true)
    document.addEventListener('keyup', this.onEscapeKey)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClickOutsidePanel, true)
    document.removeEventListener('keyup', this.onEscapeKey)
  }

  onClickOutsidePanel = (e) => {
    const { id, open, onClose } = this.props

    if ($(e.target).closest(`.js-panel-${id}`).length === 0) {
      if (open) onClose()
    }
  }

  onEscapeKey = (e) => {
    const { open, onClose } = this.props

    if (e.keyCode === 27 && open) onClose()
  }

  render() {
    const { id, open, children } = this.props
    return (
      <BasePanel className={`js-panel-${id}`} open={open}>
        {open && children}
      </BasePanel>
    )
  }
}
